import { API_ROUTES } from "../config";
import { http } from "../http";

export const getNotificationsService = async (page = 1, limit = 10, read) => {
  try {
    const params = { page, limit };
    if (read !== undefined) {
      params.read = read;
    }
    const response = await http().get(API_ROUTES.notifications, { params });
    return response.data;
  } catch (err) {
    console.error("Error fetching notifications:", err);
    throw err;
  }
};

let cachedUnreadCount = null;
let lastUnreadFetchTime = 0;
let pendingUnreadPromise = null;
const UNREAD_CACHE_TTL_MS = 30000; // 30 seconds cache to prevent repeated API calls on route changes/remounts

export const invalidateUnreadCountCache = () => {
  cachedUnreadCount = null;
  lastUnreadFetchTime = 0;
};

export const getUnreadCountService = async (forceRefresh = false) => {
  const now = Date.now();
  if (
    !forceRefresh &&
    cachedUnreadCount !== null &&
    now - lastUnreadFetchTime < UNREAD_CACHE_TTL_MS
  ) {
    return cachedUnreadCount;
  }

  // Deduplicate concurrent inflight requests
  if (pendingUnreadPromise && !forceRefresh) {
    return pendingUnreadPromise;
  }

  pendingUnreadPromise = (async () => {
    try {
      const response = await http().get(API_ROUTES["notifications-unread-count"]);
      cachedUnreadCount = response.data;
      lastUnreadFetchTime = Date.now();
      return response.data;
    } catch (err) {
      console.error("Error fetching unread count:", err);
      throw err;
    } finally {
      pendingUnreadPromise = null;
    }
  })();

  return pendingUnreadPromise;
};

export const markNotificationAsReadService = async (id) => {
  try {
    const response = await http().put(`${API_ROUTES.notifications}/${id}/read`);
    return response.data;
  } catch (err) {
    console.error(`Error marking notification ${id} as read:`, err);
    throw err;
  }
};

export const markAllNotificationsAsReadService = async () => {
  try {
    const response = await http().put(API_ROUTES["notifications-read-all"]);
    return response.data;
  } catch (err) {
    console.error("Error marking all notifications as read:", err);
    throw err;
  }
};

export const deleteNotificationService = async (id) => {
  try {
    const response = await http().delete(`${API_ROUTES.notifications}/${id}`);
    return response.data;
  } catch (err) {
    console.error(`Error deleting notification ${id}:`, err);
    throw err;
  }
};

export const deleteAllNotificationsService = async () => {
  try {
    const response = await http().delete(API_ROUTES.notifications);
    return response.data;
  } catch (err) {
    console.error("Error deleting all notifications:", err);
    throw err;
  }
};
